<template>
  <div>
    <el-dialog title="命中查询" :visible.sync="dialogVisible" :before-close="hide" width="50%" append-to-body>
      <el-form  class="query-form" ref="form" :model="form" :rules="rules" label-width="100px" size="small">
        <!-- 展示页面：必填、下拉单选 -->
        <el-form-item label="展示页面" prop="displayPage">
          <el-select v-model="form.displayPage" placeholder="请选择展示页面" size="small" clearable style="width: 300px;">
            <el-option v-for="item in displayPage" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- 渠道选择 必填、下拉搜索 -->
        <el-form-item label="渠道" prop="channelId">
          <el-select 
            v-model="form.channelId"
            filterable
            :filter-method="dataFilter"
            clearable
            placeholder="请选择渠道"
            @change="handleChannelChange"
            @visible-change="handleVisibleChange"
            style="width: 300px;"
          >
            <el-option
              v-for="item in channelShowOptions"
              :key="item.id"
              :label="getChannelLabel(item)"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 应用版本号 -->
        <el-form-item label="应用版本号" prop="appVersion" style="width: 400px;">
          <el-input v-model="form.appVersion" placeholder="请输入版本号, 正整数" clearable></el-input>
        </el-form-item>
        <!-- 协议版本号 -->
        <el-form-item label="协议版本号" prop="protocolVersion" style="width: 300px;">
          <el-select v-model="form.protocolVersion" placeholder="请选择协议版本号" size="small" clearable style="width: 300px;">
            <el-option v-for="item in protocolVersionOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- 手机厂商 -->
        <el-form-item label="手机厂商" prop="phoneBrand" style="width: 400px;">
          <el-input v-model="form.phoneBrand" placeholder="请输入手机厂商" clearable></el-input>
        </el-form-item>
        <!-- 设备UID -->
        <el-form-item label="设备UID" prop="deviceUid" style="width: 400px;">
          <el-input v-model="form.deviceUid" placeholder="请输入设备UID" clearable></el-input>
        </el-form-item>
      </el-form>
      <div class="query-btn-box">
        <el-button size="small" type="primary" @click="query"> 发起查询 </el-button>
      </div>
       <!-- 查询结果 -->
       <div class="result">
         <div v-loading="loading" class="result-content">
           <template v-if="result">
             <div v-if="isVideoPageCard">
               <div class="config-section">
                 <strong>置顶卡片配置：</strong>
                 <div>{{ JSON.stringify(topCardConfig, null, 2) }}</div>
                 <br>
               </div>
               <div class="config-section">
                 <strong>非置顶卡片配置：</strong>
                 <div>{{ JSON.stringify(regularCardConfig, null, 2) }}</div>
                 <br>
               </div>
             </div>
             <div v-else-if="isNoVideoPageCard" class="config-section">
               <strong>卡片配置：</strong>
               <div>{{ JSON.stringify(regularCardConfig, null, 2) }}</div>
               <br>
             </div>
             <div v-if="appScreenConfigRes" class="config-section">
               <strong>投屏功能配置：</strong>
               <div>{{ JSON.stringify(appScreenConfigRes, null, 2) }}</div>
               <br>
             </div>
           </template>
         </div>
       </div>
    </el-dialog>
  </div>
</template>

<script>
import { getShowPages, getProtocolVersionOptions } from "@/api/apps/pageStrategy";
import { hitQueryCard, hitQueryAppScreenConfig, hitQueryTopCard, hitQueryNotTopCard } from "@/api/pageStrategy/index.js";
import Message from "@/components/Message";
import { debounce } from 'lodash';

export default {
  name: "HitQuery",
  props: {
    channelOptions: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    channelOptions: {
      handler(newVal) {
        // 为了防止渠道过多，导致下拉框卡顿，所以只展示前50条，通过搜索框搜索
        this.channelShowOptions = newVal.slice(0, 50);
      },
      immediate: true
    }
  },
  data() {
    return {
      dialogVisible: false,
      displayPage: [],
      protocolVersionOptions: [],
      form: {
        displayPage: "",
        channelId: "",
        appVersion: "",
        protocolVersion: "",
        phoneBrand: "",
        deviceUid: ""
      },
      result: null,
      channelShowOptions: [], // 渠道展示选项
      rules: {
        displayPage: [
          { required: true, message: "请选择展示页面", trigger: "change" }
        ],
        channelId: [
          { required: true, message: "请选择渠道", trigger: "change" }
        ],
        appVersion: [
          { pattern: /^[1-9]\d*$/, message: "请输入正整数", trigger: "blur" },
          { required: true, message: "请输入应用版本号", trigger: "blur" }
        ],
        protocolVersion: [
          { required: true, message: "请选择协议版本号", trigger: "change" }
        ]
      }
    };
  },
  computed: {
     // 卡片配置数据
     cardRes() {
       return this.result && this.result.queryCardRes ? this.result.queryCardRes : [];
     },
     
     // 投屏配置数据
     appScreenConfigRes() {
       return this.result && this.result.queryAppScreenConfigRes ? this.result.queryAppScreenConfigRes : null;
     },
     
     // 是否是视频页的卡片配置
     isVideoPageCard() {
       return this.cardRes.length > 1;
     },
     
     // 是否是非视频页的卡片配置
     isNoVideoPageCard() {
       return this.cardRes.length === 1;
     },
     
     // 置顶卡片配置
     topCardConfig() {
       return this.isVideoPageCard ? this.cardRes[0] : null;
     },
     
     // 常规卡片配置（非置顶或非视频页）
     regularCardConfig() {
       if (this.isVideoPageCard) {
         return this.cardRes[1];
       } else if (this.isNoVideoPageCard) {
         return this.cardRes[0];
       }
       return null;
     }
   },
  created() {
    this.getShowPages();
    this.getProtocolVersionOptions();
  },
  methods: {
    getChannelLabel(item) {
      return `[${item.id}] ${item.name}`;
    },
    /** 获取业务字典里的展示页面 */
    async getShowPages() {
      try {
        const { data } = await getShowPages();
        if (data.code === 200) {
          this.displayPage = data.data.map((item) => {
            return {
              label: item.dictValue,
              value: Number(item.dictKey),
            };
          });
        }
      } catch (error) {
        console.error("获取展示页面失败:", error);
        Message.error("获取展示页面失败");
      }
    },
    /** 获取协议版本号 */
    async getProtocolVersionOptions() {
      try {
        const { data } = await getProtocolVersionOptions();
        if (data.code === 200) {
          this.protocolVersionOptions = data.data.map((item) => {
            return {
              label: item.dictValue,
              value: Number(item.dictKey),
            };
          });
        }
      } catch (error) {
        console.error("获取协议版本号失败:", error);
        Message.error("获取协议版本号失败");
      }
    },
     /** 渠道选择变化 */
     handleChannelChange(val) {
       this.form.channelId = val || "";
     },
     handleVisibleChange(visible) {
      if (visible) {
        this.channelShowOptions = this.channelOptions.slice(0, 50);
      } else {
        this.channelShowOptions = [];
      }
     },
     dataFilter: debounce(function(val) {
      if (val) {
        this.channelShowOptions = this.channelOptions.filter(item => this.getChannelLabel(item).toLowerCase().indexOf(val.trim().toLowerCase()) !== -1);
      } else {
        this.channelShowOptions = this.channelOptions.slice(0, 50);
      }
     }, 300),
      /** 查询 */
     async query() {
       try {
         const valid = await this.$refs.form.validate();
         if (!valid) return;

         this.loading = true;
         this.result = null;

         const hitQueryCardParams = {
           displayPage: this.form.displayPage,
           clientVersion: this.form.appVersion,
           protocolVersion: this.form.protocolVersion,
           brand: this.form.phoneBrand,
           uid: this.form.deviceUid
         };

         const hitQueryAppScreenConfigParams = {
           clientVersion: this.form.appVersion,
           uid: this.form.deviceUid
         };

          // 并行执行查询
          const [queryCardRes, queryAppScreenConfigRes] = await Promise.all([
            this.queryCardConfig(hitQueryCardParams),
            hitQueryAppScreenConfig(this.form.channelId, hitQueryAppScreenConfigParams)
          ]);

          // 验证响应状态
          if (queryAppScreenConfigRes.data.code !== 200) {
            Message.error('投屏配置查询失败');
            return;
          }

          const hasCardError = queryCardRes.some(item => item.code !== 200);
          
          if (hasCardError) {
            Message.error('卡片配置查询失败');
            return;
          }

          this.result = {
            queryCardRes: queryCardRes.map(item => item.data),
            queryAppScreenConfigRes: queryAppScreenConfigRes.data
          };

       } catch (error) {
         console.error('查询失败:', error);
         Message.error('查询失败，请稍后重试');
       } finally {
         this.loading = false;
       }
     },
           /** 查询卡片配置 */
      async queryCardConfig(params) {
        try {
          if (this.form.displayPage === 2) {
            const [topCard, notTopCard] = await Promise.all([
              hitQueryTopCard(this.form.channelId, params),
              hitQueryNotTopCard(this.form.channelId, params)
            ]);
            return [topCard.data, notTopCard.data];
          } else {
            const result = await hitQueryCard(this.form.channelId, params);
            return [result.data]; // 统一返回数组类型
          }
        } catch (error) {
          console.error('卡片配置查询失败:', error);
          Message.error('卡片配置查询失败');
          throw error; // 向上传递错误
        }
      },
    show() {
      this.dialogVisible = true;
    },
    hide() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
      this.result = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.query-form {
    width: fit-content;
    margin: 0 auto;
}
.result {
    margin-top: 20px;
    .result-content {
        border: 1px solid #ccc;
        margin: 10px;
        padding: 20px;
        border-radius: 4px;
        max-height: 300px;
        overflow: auto;
        font-family: monospace;
    }
}

.query-btn-box {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}
</style> 